/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Avatar, Typography } from '@material-ui/core';
import Password from '../constants/logins/password';
import loginService from '../services/login';
import { alert } from '../helpers/rsuite/Alerts';
import { alertError } from '../helpers';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Button from '../components/button/Button.jsx';
import Input from '../components/input/Input.jsx';

const REGEX_PASSWORD = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[[\]/#=?!@$%^&{}()|*+.:,;`'~_-]).{8,}$/;
const DIGITAL_ORIGIANTION_PLATFORM = 8;

function sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export default function ChangePassword () {
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(true);

    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');

    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [passwordConfirmError, setPasswordConfirmError] = useState('');

    const idUser = useMemo(() => localStorage.getItem('idUser'), []);
    const currentPassword = useMemo(() => localStorage.getItem('pass'), []);

    function validatePassword (value) {
        if (!REGEX_PASSWORD.test(value)) {
            setPasswordError('La contraseña debe tener entre 8 y 20 caracteres, al menos una letra mayúscula, un número y un carácter especial.');
            return false;
        }
        if (value.length < 8) {
            setPasswordError('La contraseña debe tener entre 8 y 20 caracteres, al menos una letra mayúscula, un número y un carácter especial.');
            return false;
        }
        if (value.length > 20) {
            setPasswordError('La contraseña debe tener entre 8 y 20 caracteres, al menos una letra mayúscula, un número y un carácter especial.');
            return false;
        }
        setPasswordError('');
        return true;
    }

    function validatePasswordConfirm (value) {
        if (!REGEX_PASSWORD.test(value)) {
            setPasswordConfirmError('La contraseña debe tener entre 8 y 20 caracteres, al menos una letra mayúscula, un número y un carácter especial.');
            return false;
        }
        if (value.length < 8) {
            setPasswordConfirmError('La contraseña debe tener entre 8 y 20 caracteres, al menos una letra mayúscula, un número y un carácter especial.');
            return false;
        }
        if (value.length > 20) {
            setPasswordConfirmError('La contraseña debe tener entre 8 y 20 caracteres, al menos una letra mayúscula, un número y un carácter especial.');
            return false;
        }
        setPasswordConfirmError('');
        return true;
    }

    function validate () {
        const isPasswordValid = validatePassword(password);
        const isPasswordConfirmValid = validatePasswordConfirm(password);

        if (!isPasswordValid) return false;
        if (!isPasswordConfirmValid) return false;

        if (password !== passwordConfirm) {
            setPasswordConfirmError('Las contraseñas no coinciden');
            return false;
        }

        return true;
    }

    async function submit (event) {
        try {
            event.preventDefault();

            if (!validate()) {
                return false;
            }

            setLoading(true);

            await loginService.changePassword({
                idPlatform: DIGITAL_ORIGIANTION_PLATFORM,
                idUser,
                currentPassword,
                password,
            });

            setLoading(false);
            alert('success', 'La contraseña fue cambiada correctamente.');
            localStorage.removeItem('pass');
            history.push('/auth/login');
        }
        catch (error) {
            setLoading(false);
            localStorage.removeItem('pass');

            const dataError = error?.response?.data;

            if (dataError?.extra?.key === Password.invalid) {
                return alertError('La contraseña es incorrecta.', showAlert, setShowAlert);
            }

            if (dataError?.extra?.key === Password.alreadyUsed) {
                return alertError('La contraseña ya ha sido usada anteriormente.', showAlert, setShowAlert);
            }

            return alertError('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', showAlert, setShowAlert);
        }
    };

    async function validateUser () {
        if (currentPassword && idUser) {
            await sleep(500);
            alert('success', 'El usuario fue validado correctamente. Por Favor, ingrese su nueva contraseña.');
            return;
        }
        localStorage.removeItem('idUser');
        localStorage.removeItem('pass');
        await sleep(1000);
        alert('error', 'Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 4000);
        await sleep(3000);
        history.push('/auth/login');
    };

    useEffect(() => {
        // Validate user using currentPassword and idUser
        validateUser();
    }, []);

    return (
        <main>
            <Avatar>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Log in
            </Typography>
            <form id="form-change-password" onSubmit={submit}>
                <Input
                    required
                    type="password"
                    name="passwordConfirm"
                    label="Nueva Contraseña"
                    autocomplete="new-password"
                    value={password}
                    error={passwordError}
                    onChange={setPassword}
                    onBlur={validatePassword}
                />
                <Input
                    required
                    type="password"
                    name="passwordConfirm"
                    label="Confirme Contraseña"
                    autocomplete="new-password"
                    value={passwordConfirm}
                    error={passwordConfirmError}
                    onChange={setPasswordConfirm}
                    onBlur={validatePasswordConfirm}
                />
            </form>
            <Button type="submit" form="form-change-password" block loading={loading}>
                Aceptar
            </Button>
        </main>
    );
}
